export default "__VITE_ASSET__ziy634yR__"